// src/pages/ContactPage.js
import React from 'react';
import { Box, Container } from '@mui/material';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { TextProvider } from '../context/TextContext';

const ContactPage = () => {
  return (
    <TextProvider>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#F3F2F1' }}>
        <Header />
        <Container sx={{ flex: 1 }}>
          <Contact />
        </Container>
        <Footer />
      </Box>
    </TextProvider>
  );
};

export default ContactPage;

